<top-banner variant="custom">
    <h2 class="title mb-3">Site Sessions</h2>
    <button type="button" (click)="export();" class="btn btn-success btn-round"><i class="fas fa-plus"></i>
      &nbsp;
      <strong>EXPORT CSV</strong>
    </button>
</top-banner>


<div class="main-content">
  <div class="row animated fadeIn">
    <div class="col-md-12">
      <div class="card">
        <div class="card-body mb-2">
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label>From</label>
                <p-calendar class="form-control" [(ngModel)]="fromDate" (ngModelChange)="onFromDateChange($event)" dateFormat="dd/mm/yy"></p-calendar>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>To</label>
                <p-calendar class="form-control" [(ngModel)]="toDate" (ngModelChange)="onToDateChange($event)" dateFormat="dd/mm/yy"></p-calendar>
              </div>
            </div>
            <div class="col-md-6" *ngIf="sitesArray.length">
              <div class="form-group">
                <label>Site</label>
                <p-dropdown
                    class="form-control"
                    [(ngModel)]="selectedSite"
                    (ngModelChange)="onSelectedSiteChange($event)"
                    [options]="sitesArray"
                    optionLabel="label"
                    defaultLabel="Select Site"
                    [style]="{'width':'100%'}"
                ></p-dropdown>
              </div>
            </div>
            <div class="col-md-6" *ngIf="companiesArray.length">
              <div class="form-group">
                <label>Contractor</label>
                <p-dropdown
                    class="form-control"
                    [(ngModel)]="selectedCompany"
                    (ngModelChange)="onSelectedCompanyChange($event)"
                    [options]="companiesArray"
                    optionLabel="label"
                    defaultLabel="Select Company"
                    [style]="{'width':'100%'}"
                ></p-dropdown>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <p-table [value]="siteSessions" selectionMode="single">
                <ng-template pTemplate="header">
                  <tr>
                    <th>Id</th>
                    <th>Site</th>
                    <th>Company</th>
                    <th>Created By</th>
                    <th>Start time</th>
                    <th>End Time</th>
                    <th>Work Order ID</th>
                    <th>Work Order</th>
                    <th>WO Status</th>
                    <th>Asset</th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-siteSession>
                  <tr [pSelectableRow]="siteSession">
                    <td>{{siteSession.id}}</td>
                    <td>{{siteSession.site.name}}</td>
                    <td>
                      <span *ngFor="let comp of siteSession.maintenances">
                        {{comp.name}}
                      </span>
                    </td>
                    <td>{{siteSession.createdBy}}</td>
                    <td>{{siteSession.startTime | date : 'E d MMM yyyy HH:mm'}}</td>
                    <!-- First End Time handles site session that has ended and has an end time
                        Second End Time handles a site session that is still open -->
                    <td *ngIf="siteSession.endTime !== null">{{siteSession.endTime | date : 'E d MMM yyyy HH:mm'}}</td>
                    <td *ngIf="siteSession.endTime === null">
                      <span class="badge badge-pill badge-warning">In Progress</span>
                    </td>
                    <!-- First WO handles a standard site session a company starts Second WO field handles 'manager' sessions which don't have WOs -->
                    <ng-container *ngIf="siteSession.workOrder !== null">
                      <td>{{siteSession.workOrder.id}}</td>
                      <td>{{siteSession.workOrder.description}}</td>
                    </ng-container>
                    <ng-container *ngIf="siteSession.workOrder === null">
                      <td></td>
                      <td>
                        <span class="badge badge-pill badge-primary">Site Session</span>
                      </td>
                    </ng-container>
                    <!-- First WO Status handles a standard site session a company starts
                        Second WO field handles 'manager' sessions which don't have WOs -->
                    <td *ngIf="siteSession.workOrder !== null">
                      <span *ngIf="siteSession.workOrder.status === 'AVAILABLE'" class="badge badge-pill badge-primary">Available</span>
                      <span *ngIf="siteSession.workOrder.status === 'OPEN'" class="badge badge-pill badge-success">Open</span>
                      <span *ngIf="siteSession.workOrder.status === 'SUSPENDED'" class="badge badge-pill badge-warning">Suspended</span>
                      <span *ngIf="siteSession.workOrder.status === 'SURRENDERED'" class="badge badge-pill badge-danger">Surrendered</span>
                      <span *ngIf="siteSession.workOrder.status === 'CLOSED'" class="badge badge-pill badge-secondary">Closed</span>
                    </td>
                    <td *ngIf="siteSession.workOrder === null">N/A</td>
                    <!-- First Asset handles a standard WO which has an asset
                        Second Asset handles a manager visit, which has no asset -->
                    <td *ngIf="siteSession.workOrder !== null">{{siteSession.workOrder.asset.name}}</td>
                    <td *ngIf="siteSession.workOrder === null">
                      N/A
                    </td>
                  </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage" let-columns>
                  <tr>
                    <td [attr.colspan]="9">
                      No site sessions found
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </div>
        </div>
        <div class="card-footer">
          <p-paginator #paginator [rows]="pagination.size" [totalRecords]="pagination.totalRecords" [rowsPerPageOptions]="pageSizes" (onPageChange)="paginate($event)"></p-paginator>
        </div>
      </div>
    </div>
  </div>
</div>
